export const normalizeBankAccount = (value: string): string => {
  if (!value) return value;
  const [reg = '', acc = ''] = value.split('-');
  const regDigits = reg.replace(/\D/g, '');
  const accDigits = acc.replace(/\D/g, '');
  if (!accDigits) return regDigits;
  return `${regDigits}-${accDigits.padStart(10, '0')}`;
};
